import { TenantEntity } from '../TenantEntity'
import { loadFbaQuotationRelated } from '@/api/price/fbaQuotation'

export class FbaQuotation extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'FbaQuotation'
  }

  get quotationNo() {
    return this._data.quotationNo
  }
  set quotationNo(quotationNo) {
    this._data.quotationNo = quotationNo
  }
  get serviceChannel() {
    return this._data.serviceChannel
  }
  set serviceChannel(serviceChannel) {
    this._data.serviceChannel = serviceChannel
  }
  get beginDate() {
    return this._data.beginDate
  }
  set beginDate(beginDate) {
    this._data.beginDate = beginDate
  }
  get endDate() {
    return this._data.endDate
  }
  set endDate(endDate) {
    this._data.endDate = endDate
  }
  get active() {
    return this._data.active
  }
  set active(active) {
    this._data.active = active || false
  }
  get note() {
    return this._data.note
  }
  set note(note) {
    this._data.note = note
  }
  get hasJob() {
    return this._data.hasJob
  }
  set hasJob(hasJob) {
    this._data.hasJob = hasJob || false
  }
  get jobNo() {
    return this._data.jobNo
  }
  set jobNo(jobNo) {
    this._data.jobNo = jobNo
  }
  get chargePartType() {
    return this._data.chargePartType
  }
  set chargePartType(chargePartType) {
    this._data.chargePartType = chargePartType || 0
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId || 0
  }

  /* =============扩展属性================= */
  // 标签
  get labelList() {
    return this._data.labelList
  }
  set labelList(labelList) {
    this._data.labelList = labelList
  }
  // 分区
  get partitionSettingList() {
    return this._data.partitionSettingList
  }
  set partitionSettingList(partitionSettingList) {
    this._data.partitionSettingList = partitionSettingList
  }
  // 阶梯
  get setupSettingList() {
    return this._data.setupSettingList
  }
  set setupSettingList(setupSettingList) {
    this._data.setupSettingList = setupSettingList
  }
  // 费用
  get chargeList() {
    return this._data.chargeList
  }
  set chargeList(chargeList) {
    this._data.chargeList = chargeList
  }
  // 客户价
  get customerPriceList() {
    return this._data.customerPriceList
  }
  set customerPriceList(customerPriceList) {
    this._data.customerPriceList = customerPriceList
  }
  // 加载Quotation的关联实体信息
  async loadFbaQuotationRelated(params) {
    params.quotationUuid = params.quotationUuid || this._data.uuid
    if (!params.quotationUuid) return
    // 是否需要载入
    let needLoad = false
    // 将已经加载过的属性的标识置为false
    for (const key in params) {
      if (key === 'quotationUuid') {
        continue
      }
      if (key !== 'quotation' && params[key] && typeof this._data[key] === 'object') {
        params[key] = false
      }
      if (params[key]) {
        needLoad = true
      }
    }
    if (!needLoad) {
      return
    }
    await loadFbaQuotationRelated(params).then(res => {
      const items = res.data
      if (items.quotation) {
        for (const key in items.quotation) {
          if (typeof this._data[key] === 'object') {
            continue
          }
          this._data[key] = items.quotation[key]
        }
      }
      for (const key in items) {
        if (key === 'quotation') continue
        this._data[key] = items[key] || null
      }
    })
  }
}
